import axios from 'axios';

class ServiceWebflowController {
  async getWebflowLogos() {
    const response = await axios.get('/api/webflow/logos');
    if (response.status !== 200) {
      console.error(response.error);
      return [];
    }
    return response.data;
  }
}

export const ServiceWebflow = new ServiceWebflowController();